import axios from '@/axios'

export default {
  getById(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/packages/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getAll() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/packages`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  create(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/packages`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  update(item) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/packages`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  updateMediaIds(item) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/packages/media_ids`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  remove(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/packages/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
